import { useState } from "react"
import { useNavigate } from "react-router-dom"
import Swal from "sweetalert2"
import logo from "../assets/logo-inmobiliaria.jpeg"
import "../styles/login.css"
import { loginUser as loginUserAPI } from "../actions/user-actions"
import { useApp } from "../context/useApp"
import {
  BsFillEyeFill,
  BsFillEyeSlashFill,
  BsEnvelope,
  BsLock,
} from "react-icons/bs"

function Login() {
  const navigate = useNavigate()
  const { loginUser, setLoading } = useApp()

  const [user, setUser] = useState("")
  const [pass, setPass] = useState("")
  const [showPassword, setShowPassword] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  const handleLogin = async (e) => {
    e.preventDefault()

    if (user.trim() === "" || pass.trim() === "") {
      Swal.fire({
        title: "¡Atención!",
        confirmButtonColor: "#76b4ff",
        icon: "warning",
        text: "Por favor completa todos los campos",
      })
      return
    }

    setIsLoading(true)
    try {
      const userData = await loginUserAPI(user, pass, setLoading)
      loginUser(userData)
      navigate("/")
    } catch (error) {
      console.error("Login failed:", error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="login-container">
      <div className="login-wrapper">
        {/* Left side - Branding */}
        <div className="login-brand-section">
          <div className="brand-content">
            <div className="brand-logo-container">
              <img alt="Inmobiliaria Logo" src={logo} className="brand-logo" />
            </div>
            <h1 className="brand-title">AyH Inmobiliaria</h1>
            <p className="brand-subtitle">Sistema de Gestión Inmobiliaria</p>
            <div className="brand-features">
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <span>Gestión eficiente</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <span>Seguridad confiable</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <span>Acceso rápido</span>
              </div>
            </div>
            <div className="brand-footer">
              <p>
                Desarrollado por <span className="brand-credit">CasaApp</span>
              </p>
            </div>
          </div>
        </div>

        {/* Right side - Login Form */}
        <div className="login-form-section">
          <div className="login-form-wrapper">
            <div className="form-header">
              <h2>Bienvenido</h2>
              <p>Ingresa tus credenciales para continuar</p>
            </div>

            <form onSubmit={handleLogin} className="login-form">
              {/* Email Input */}
              <div className="form-group">
                <label htmlFor="email" className="form-label">
                  <BsEnvelope className="input-icon" />
                  Correo o Usuario
                </label>
                <input
                  id="email"
                  type="text"
                  className="form-input"
                  placeholder="ejemplo@correo.com"
                  value={user}
                  onChange={(e) => setUser(e.target.value)}
                  disabled={isLoading}
                />
              </div>

              {/* Password Input */}
              <div className="form-group">
                <label htmlFor="password" className="form-label">
                  <BsLock className="input-icon" />
                  Contraseña
                </label>
                <div className="password-input-wrapper">
                  <input
                    id="password"
                    type={showPassword ? "text" : "password"}
                    className="form-input"
                    placeholder="Ingresa tu contraseña"
                    value={pass}
                    onChange={(e) => setPass(e.target.value)}
                    disabled={isLoading}
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={togglePasswordVisibility}
                    disabled={isLoading}
                    aria-label="Toggle password visibility"
                  >
                    {showPassword ? <BsFillEyeSlashFill /> : <BsFillEyeFill />}
                  </button>
                </div>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="login-button"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="spinner"></span>
                    Ingresando...
                  </>
                ) : (
                  "INGRESAR"
                )}
              </button>
            </form>

            {/* Footer */}
            <div className="form-footer">
              <p>¿Problemas para acceder? Contacta al administrador</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login
